import { XMarkIcon } from "@heroicons/react/24/solid";
import MainButton from "../sharedComponents/MainButton";
import { useTranslation } from "react-i18next";

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, post }) => {
    const { t } = useTranslation();

    if (!post) return null;

    return (
        <div
            className={`mt-0 fixed inset-0 z-[999] flex items-center justify-center transition-all duration-300 ${isOpen ? "visible" : "invisible"
                }`}
        >
            {/* Overlay */}
            <div
                onClick={onClose}
                className={`absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0"
                    }`}
            />

            {/* Modal */}
            <div
                className={`relative z-10 w-full max-w-md p-6 rounded-2xl bg-white dark:bg-gray-800 shadow-lg transform transition-all duration-300 ease-out
        ${isOpen ? "opacity-100 scale-100 translate-y-0" : "opacity-0 scale-95 translate-y-6"}`}
            >
                {/* Header */}
                <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-semibold text-black dark:text-white">
                        {t("confirmDelete.title")}
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-black dark:hover:text-white"
                    >
                        <XMarkIcon className="w-5 h-5" />
                    </button>
                </div>

                {/* Body */}
                <p className="mb-4 text-gray-700 dark:text-gray-300">
                    {t("confirmDelete.message")}
                </p>

                {/* Footer */}
                <div className="flex justify-end gap-3">
                    <MainButton
                        onClick={onClose}
                        // className="text-black bg-gray-300 dark:bg-gray-600 dark:text-white"
                    >
                        {t("common.cancel")}
                    </MainButton>

                    <MainButton
                        onClick={() => onConfirm(post.id)}
                        // className="text-white bg-red-500"
                    >
                        {t("common.delete")}
                    </MainButton>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDeleteModal;
